import { Button } from '@/components/ui/button';
import { RefreshCcw } from 'lucide-react';

export function ResetEventsButton({ onClick }: { onClick: () => void }) {
  return (
    <Button
      type="button"
      variant="outline"
      onClick={onClick}
      className="p-0 border-none rounded-md hover:text-gray-700 transition-colors text-gray-500 h-4"
    >
      <RefreshCcw className="h-4 w-4 mr-2" />
    </Button>
  );
}
